export const adminProducts = [
  { id: 1, name: 'Premium Ajwa Dates', price: 120, stock: 45, category: 'Food & Dates', sold: 210 },
  { id: 2, name: 'Embroidered Prayer Gloves', price: 180, stock: 32, category: 'Clothing', sold: 76 },
  { id: 3, name: 'Premium Niqab', price: 150, stock: 28, category: 'Clothing', sold: 132 },
  { id: 4, name: 'Tasbih Prayer Beads', price: 95, stock: 67, category: 'Accessories', sold: 340 },
  { id: 5, name: 'Silk Hijab', price: 130, stock: 54, category: 'Clothing', sold: 198 },
  { id: 6, name: 'Luxury Velvet Prayer Mat', price: 85, stock: 40, category: 'Accessories', sold: 145 },
  { id: 7, name: 'Royal Oud Perfume', price: 250, stock: 18, category: 'Fragrance', sold: 89 },
  { id: 8, name: 'Natural Organic Henna', price: 45, stock: 90, category: 'Beauty', sold: 267 },
];

export const adminCategories = [
  { id: 1, name: 'Food & Dates', products: 1, revenue: 25200, color: '#d4af37' },
  { id: 2, name: 'Clothing', products: 3, revenue: 78140, color: '#f3e5ab' },
  { id: 3, name: 'Accessories', products: 2, revenue: 44625, color: '#c9a86a' },
  { id: 4, name: 'Fragrance', products: 1, revenue: 22250, color: '#8c7322' },
  { id: 5, name: 'Beauty', products: 1, revenue: 12015, color: '#a3821a' },
];

export const adminCustomers = [
  { id: 0, name: 'Sara Al-Madani', email: 'customer@baytalkhayr.com', orders: 4, spent: 680, joined: '2026-07-01', country: 'Saudi Arabia', isTestAccount: true },
  { id: 1, name: 'Ahmed Ali', email: 'ahmed.ali@email.com', orders: 12, spent: 2450, joined: '2026-01-15', country: 'Saudi Arabia' },
  { id: 2, name: 'Fatima Khan', email: 'fatima.khan@email.com', orders: 8, spent: 1680, joined: '2026-02-20', country: 'UAE' },
  { id: 3, name: 'Mohammed Hassan', email: 'm.hassan@email.com', orders: 15, spent: 3200, joined: '2025-11-05', country: 'Qatar' },
  { id: 4, name: 'Aisha Rahman', email: 'aisha.r@email.com', orders: 5, spent: 890, joined: '2026-03-10', country: 'UK' },
  { id: 5, name: 'Yusuf Ibrahim', email: 'yusuf.i@email.com', orders: 21, spent: 4870, joined: '2025-09-01', country: 'USA' },
  { id: 6, name: 'Layla Ahmed', email: 'layla.a@email.com', orders: 3, spent: 420, joined: '2026-04-22', country: 'Egypt' },
];

export const adminOrders = [
  { id: 1001, customer: 'Ahmed Ali', total: 450, status: 'Completed', date: '2026-08-01', items: 3 },
  { id: 1002, customer: 'Fatima Khan', total: 320, status: 'Pending', date: '2026-08-03', items: 2 },
  { id: 1003, customer: 'Mohammed Hassan', total: 680, status: 'Shipped', date: '2026-08-02', items: 5 },
  { id: 1004, customer: 'Aisha Rahman', total: 210, status: 'Completed', date: '2026-08-04', items: 1 },
  { id: 1005, customer: 'Yusuf Ibrahim', total: 920, status: 'Shipped', date: '2026-08-03', items: 6 },
  { id: 1006, customer: 'Layla Ahmed', total: 150, status: 'Pending', date: '2026-08-05', items: 1 },
];

export const monthlySales = [
  { month: 'Feb', value: 12500 },
  { month: 'Mar', value: 15800 },
  { month: 'Apr', value: 14200 },
  { month: 'May', value: 18900 },
  { month: 'Jun', value: 21400 },
  { month: 'Jul', value: 19600 },
  { month: 'Aug', value: 24800 },
];
